<template>
    <div style="padding:20px 100px;">
        <file-upload class="f-edit" v-model="ruleForm.attaches"
                     :action="action"
                     :data="{resumeId: rid}"
                     :on-success="uploadSuccess"
                     :on-remove="uploadRemove"
                     :fileList="fileList">
            <el-button type="primary">点击上传</el-button>
        </file-upload>
        <div class="f-view">
            <template v-if="fileList.length" v-for="(item, index) in fileList">
                <p>
                    <a v-if="item.preUrl" target="_blank"
                       :href="item.preUrl">{{ item.name }}</a>
                    <span v-else>{{ item.name }}</span>
                    <a :href="item.downUrl" class="ml-10 mr-10"><i class="el-icon-my-daochu"></i></a>
                </p>
            </template>
        </div>
    </div>
</template>
<script type="text/javascript">
    import axios from 'axios'
    import _ from 'underscore'
    import qs from 'qs'
    import FileUpload from 'components/fileUpload'

    const fieldName = 'resumeAttachs'

    export default {
        props: {
            init: {
                type: Array,
                required: true
            },
            rid: [Number, String],
            action: {
                type: String,
                default () {
                    return `${axios.defaults.baseURL}/resumeAttach/resumefileInsert.api`
                }
            }
        },
        data () {
            return {
                urls: {
                    remove: '/resume/resumeAttach/delete.api'
                },
                ruleForm: {
                    attaches: []
                },
                fileList: []
            }
        },
        watch: {
            init (newValue) {
                this.ruleForm.attaches = []
                this.fileList = []
                newValue.forEach((item, index) => {
                    this.ruleForm.attaches.push({
                        fileId: item.fileId,
                        md5: item.md5,
                        resumeId: item.resumeId
                    })
                    this.fileList.push({
                        name: item.name,
                        fileId: item.fileId,
                        md5: item.md5,
                        status: 'finished',
                        downUrl: item.downUrl,
                        preUrl: item.preUrl
                    })
                })
            }
        },
        computed: {
            postData () {
                return Object.assign({}, this.ruleForm, {
                    'resumePositionId': this.$route.params.id
                })
            }
        },
        methods: {
            uploadSuccess (res, file) {
                console.log('attach:', res, file)
            },
            updateData () {
                axios.post(this.urls.update, this.postData, {'X-showMessage': true}).then((res) => {
                    this.editData()
                })
            },
            removeData () {
                let removeData = _.pick(this.postData, ['id', 'resumeId', 'resumePositionId'])
                this.$confirm('是否删除该记录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post(this.urls.remove, removeData, {'X-showMessage': true}).then(res => {
                        this.$emit('remove', removeData, fieldName)
                    })
                })
            },
            saveData (callback) {
                callback(this.ruleForm.attaches)
            },
            uploadRemove (file, fileList) {
                let targetIndex = '',
                    fileId = (file.response && file.response.result.fileId) || file.fileId
                this.ruleForm.attaches.forEach((item, index) => {
                    if (fileId === item.fileId) {
                        targetIndex = index
                    }
                })
                if (targetIndex !== '' && targetIndex >= 0) {
                    this.ruleForm.attaches.splice(targetIndex, 1)
                }
            }
        },
        components: {
            FileUpload
        }
    }

</script>
<style type="text/css" lang="scss">
</style>


// WEBPACK FOOTER //
// attach.vue?2a50c683